import React from 'react'

interface FlexProps {
  children?: React.ReactNode
  testId?: string
  flexDirection?: 'row' | 'column'
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'initial'
    | 'inherit'
  flexWrap?: 'wrap' | 'nowrap' | 'wrap-reverse'
  alignItems?: 'stretch' | 'center' | 'flex-start' | 'flex-end'
  alignContent?: 'stretch' | 'center' | 'flex-start' | 'flex-end'
  gap?: string
  flex?: string
  minWidth?: string
  style?: React.CSSProperties
}

export const Flex = ({
  testId,
  justifyContent,
  flexDirection,
  flexWrap,
  gap,
  alignItems,
  alignContent,
  children,
  flex,
  minWidth,
  style,
}: FlexProps) => (
  <div
    data-testid={testId}
    style={{
      display: 'flex',
      justifyContent: justifyContent,
      flexDirection: flexDirection,
      flexWrap: flexWrap,
      gap: gap,
      alignItems: alignItems,
      alignContent: alignContent,
      flex: flex,
      minWidth,
      ...style,
    }}
  >
    {children}
  </div>
)
